import React from 'react';

/**
 * Two inclined parallelograms forming the brand mark "\\".
 * Bars are individually animatable (via clip-path or transform) with refs.
 * Colors follow currentColor for easy theming.
 *
 * Slant direction — matches the OFFICIAL brand SVG (araia ALL design_logo.svg,
 * paths `M3216,0 L3387,0 L3575.9,705 L3404.9,705`):
 *   TOP-LEFT → BOTTOM-RIGHT
 * In parallelogram terms: top edge sits at SMALLER x (left), bottom edge at
 * LARGER x (right). Programmatic verification on the client's own PNG:
 *   top_x=183  vs  bottom_x=749  → bottom > top  → backslash confirmed.
 */
const LogoSlashSVG = React.forwardRef(function LogoSlashSVG(
    { className = 'intro-slash-svg', barClassName = 'intro-slash-bar', ...props },
    ref,
) {
    return (
        <svg
            ref={ref}
            className={className}
            viewBox="0 0 220 240"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            {/* Two inclined bars (~15° tilt) forming the brand "\\" glyph. */}
            <polygon
                className={`${barClassName} intro-slash-bar--1`}
                data-bar="1"
                points="30,20 90,20 130,220 70,220"
                fill="currentColor"
            />
            <polygon
                className={`${barClassName} intro-slash-bar--2`}
                data-bar="2"
                points="120,20 180,20 220,220 160,220"
                fill="currentColor"
            />
        </svg>
    );
});

export default LogoSlashSVG;
